import { type BoxProps } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import React, { type PropsWithChildren } from 'react'

import { useMenus } from '../../hooks/useMenus'
import { NavbarDesktop } from './NavbarDesktop'
import { NavbarMobile } from './NavbarMobile'

export function Navbar(props: PropsWithChildren<BoxProps>) {
  const { shouldRenderNavbar } = useMenus()
  const isMobile = useMediaQuery('(max-width: 760px)')
  const isMobileOnLandscape = useMediaQuery(
    '(max-width: 935px) and (max-height: 500px)'
  )

  if (!shouldRenderNavbar) {
    return null
  }

  return isMobile || isMobileOnLandscape ? (
    <NavbarMobile {...props} />
  ) : (
    <NavbarDesktop {...props} />
  )
}
